import * as z from "zod";

export const getRecoverSettings = {
  name: "getRecoverSettings" as const,
  input: z.object({}),
  output: z
    .object({
      defaultRepName: z.string().nullable(),
      brandName: z.string().nullable(),
      initialOutreachCooldownHours: z.number().nullable(),
    })
    .nullable(),
};
